import React, { useEffect, useState } from 'react';
import { Card, Layout } from "antd";


import { MDBCol, MDBRow } from "mdbreact";
import { Text } from "react-font";
import { Badge, Button, Dialog, SearchInput, Spinner } from "evergreen-ui";
import { Table } from 'antd';
import Firebase from "../Firebase/Firebase";
import FireFetch from "../Firebase/FireFetch";
import { TableExport } from "tableexport";
import { useListVals } from "../Firebase/databaseHooks";
import EditTask from "../Modals/Tasks/EditTask";
import AddTask from "../Modals/Tasks/AddTask";
import ViewTask from "../Modals/Tasks/ViewTask";
import TaskUploadModal from "../Modals/UploadModals/TaskUploadModal";
import { getDatabase, ref } from "firebase/database";
import { getDownloadURL, getStorage, listAll, ref as storageRef } from "firebase/storage";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import moment from "moment";
import { useAuth } from "../AuthContext/AuthContext";
import TableActionMenu from "../Common/TableActionMenu";


const columns = [
	{
		title: 'Task',
		dataIndex: 'task',
		key: 'task',
		sorter: (a, b) => a.task && a.task.localeCompare(b.task)
	},
	{
		title: 'Created',
		dataIndex: 'created',
		key: 'created',
		sorter: (a, b) => moment(a.created, "DD/MMM/YYYY HH:MM").diff(moment(b.created, "DD/MMM/YYYY HH:MM"))
	},

	{
		title: 'Due Date',
		dataIndex: 'dueDate',
		key: 'dueDate',
		responsive: ["sm"],
		sorter: (a, b) => a.dueDate && a.dueDate.localeCompare(b.dueDate)
	},
	{
		title: 'Task Status',
		dataIndex: 'status',
		key: 'status',
		sorter: (a, b) => a.status.props.children.localeCompare(b.status.props.children)
	},
	{
		title: 'Created By',
		key: 'createdBy',
		dataIndex: 'createdBy',
		responsive: ["sm"],
		sorter: (a, b) => a.createdBy && a.createdBy.localeCompare(b.createdBy)

	}, {
		title: 'Assigned To',
		key: 'assigned',
		dataIndex: 'assigned',
		responsive: ["sm"],
		sorter: (a, b) => a.assigned && a.assigned.localeCompare(b.assigned)

	},
	{
		title: 'Action',
		key: 'action',
		dataIndex: 'action',

	},
];

var storage = getStorage(Firebase);
var db = getDatabase(Firebase);
var auth = getAuth(Firebase);
const Tasks = (props) => {
	const { canAccessModule } = useAuth();
	const canCreateTask = canAccessModule("TASKS", "create");
	const canUpdateTask = canAccessModule("TASKS", "update");
	const canDeleteTask = canAccessModule("TASKS", "delete");

	const [checkedData, setCheckedData] = useState(false);
	const [dataArray, setDataArray] = useState([]);
	const [eventsData, setEventsData] = useState([]);
	const [taskArray, loading] = useListVals(ref(db, "talmidsdb/Tasks"))
	const [userArray] = useListVals(ref(db, "talmidsdb/users"))
	const [searchValue, setSearchValue] = useState();
	const [showModal, setShowModal] = useState(false);
	const [viewModal, setViewModal] = useState(false);
	const [selectedTask, setSelectedTask] = useState(null);
	const [editModal, setEditModal] = useState(false);
	const [uploadModal, setUploadModal] = useState(false);
	const [editLoading, setEditLoading] = useState(false);
	const [loadID, setLoadID] = useState();

	const callback = (data) => {
		setCheckedData(data);
	}

	useEffect(() => {
		setEventsData([]); setDataArray([]);

		onAuthStateChanged(auth, function (user) {
			if (user) {
				if (taskArray) {
					taskArray.map((item) => {
						item.urls = [];
						listAll(storageRef(storage, "talmidsdb/Tasks/" + item.taskID))
							.then((res) => {
								res.items.forEach((itemRef) => {
									// All the items under listRef.
									getDownloadURL(itemRef).then((url) => {
										item.urls.push(url);
									})
								});
							}).catch((error) => {
								// Uh-oh, an error occurred!
							});
					});

					var analyzed = taskArray;
					if (userArray?.findIndex(x => (user.uid) === x.id)
						&& userArray?.findIndex(x => (user.uid) === x.id)?.userRole !== "SuperUser") {
						//console.log("not super user");

						analyzed = analyzed?.slice().filter((v, i, a) => a?.findIndex(t => ((t.assignedTo === user.uid) || t.createdBy === user.uid)) === i);
						taskArray.map((task) => {
							if (userArray.find(x => (task.assignedTo) === x.id)?.supervisor === user.uid) {
								console.log("supervised");
								analyzed.push(task);
							}
						})
					}
					var tempArray = [];
					analyzed.map((item, index) => {

						tempArray.push({
							key: index + 1,
							task: item.task,
							createdBy: userArray[userArray?.findIndex(x => (item.createdBy) === x.id)] &&
								userArray[userArray?.findIndex(x => (item.createdBy) === x.id)].firstname + " "
								+ userArray[userArray?.findIndex(x => (item.createdBy) === x.id)].surname,

							assigned: userArray[userArray?.findIndex(x => (item.assignedTo) === x.id)] &&
								userArray[userArray?.findIndex(x => (item.assignedTo) === x.id)].firstname + " "
								+ userArray[userArray?.findIndex(x => (item.assignedTo) === x.id)].surname,
							taskStatus: item.taskStatus,
							status: <Badge color={item.taskStatus === "Pending" ? "neutral" : "green"}>{item.taskStatus}</Badge>,
							dueDate: item.dueDate,
							created: moment(item.createdDate).format("DD/MMM/YYYY HH:MM"),
							action: (
								<TableActionMenu
									items={[
										{
											key: "view",
											label: "View",
											onClick: () => { setSelectedTask(item); setViewModal(true); },
										},
										canUpdateTask && {
											key: "edit",
											label: "Edit",
											onClick: () => { setSelectedTask(item); setEditModal(true); },
										},
										canDeleteTask && {
											key: "delete",
											label: "Delete",
											danger: true,
											onClick: () => {
												if (!canDeleteTask) {
													alert("You do not have permission to delete tasks.");
													return;
												}

												if (confirm("Are you sure you want to delete Task?")) {
													FireFetch.DeleteFromDB("Tasks", item.taskID).then((message) => {
														if (message === "success") {
															FireFetch.addLog("Tasks", item.taskID, "Delete");
															storageRef.child(item.taskID).listAll()
																.then((res) => {
																	res.items.forEach((itemRef) => {
																		itemRef.delete().then(() => {
																			console.log("deleted");
																		}).catch(() => {
																		});
																	});
																}).catch(() => {
																});
														} else {
															alert("Unable to delete");
														}
													}).catch(() => {
														alert("Unable to delete");
													});
												}
											},
										},
									]}
								/>
							)
						});
					});
					setEventsData([...tempArray]);
					setDataArray([...tempArray]);
				}

			} else {
				// No user is signed in.
				window.location.href = "/login";
			}
		});
	}, [taskArray, userArray]);

	const handleSearch = searchText => {
		const filteredEvents = dataArray.filter(({ task, assigned }) => {
			task = task.toLowerCase();
			assigned = assigned && assigned.toLowerCase();
			return task.includes(searchText) || (assigned && assigned.includes(searchText));
		});

		setEventsData(filteredEvents);
	};

	return (
		<div className="d-flex justify-content-center align-items-center pt-4 mt-4">
			<Dialog
				isShown={showModal}
				title="Create New Task"
				onCloseComplete={() => { setShowModal(false) }}
				confirmLabel="Create"
				className="font-Nunito"
				hasFooter={false}
				shouldCloseOnOverlayClick={false}
			>
				<AddTask modal={setShowModal} />
			</Dialog>
			<Dialog
				isShown={editModal}
				title="Edit Task"
				width={window.innerWidth - 600}
				className="font-Nunito"
				hasFooter={false}
				onCloseComplete={() => { setEditModal(false) }}
				shouldCloseOnOverlayClick={false}
			>
				<EditTask modal={setEditModal} task={selectedTask} />
			</Dialog>
			<Dialog
				isShown={viewModal}
				title="View Task"
				width={window.innerWidth - 600}
				className="font-Nunito"
				onCloseComplete={() => { setViewModal(false) }}
				hasFooter={false}
			>
				<ViewTask task={selectedTask} />
			</Dialog>
			<TaskUploadModal showModal={uploadModal} name={"Tasks"} id={"task"} />
			<MDBRow className="w-100">
				<MDBCol md={12}>
					<Card className="w-100">
						<MDBRow>
							<MDBCol md={12}>
								<div className="text-left">
									<div className="d-flex flex-row justify-content-between">
										<div className="d-inline">
											<h5 className="font-weight-bold" style={{ color: '#51195D' }}>
												<Text family='Nunito'>
													Tasks
												</Text>
											</h5>
										</div>
										<div className="d-flex flex-row">
											<SearchInput placeholder="Filter through tasks" onChange={e => handleSearch(e.target.value)} value={searchValue} />
											{canCreateTask && (
												<Button appearance="primary" className="mx-1" onClick={() => { setShowModal(true) }}>
													New Task
												</Button>
											)}
											<Button appearance="primary" className="mx-1" onClick={() => {
												FireFetch.exportXL(TableExport(document.getElementById("dataTable"), {
													filename: "Tasks",
													exportButtons: false,
													sheetname: "Tasks",
												}), eventsData);
											}}>
												Print
											</Button>
											{canCreateTask && (
												<Button appearance="primary" className="mx-1"
													onClick={() => { setUploadModal(!uploadModal) }}>
													Upload
												</Button>
											)}
										</div>

									</div>
								</div>
							</MDBCol>
						</MDBRow>
					</Card>
					<Card>
						<Table id="dataTable"
							className="custom-table"
							style={{ overflow: "auto" }}
							pagination={{ defaultPageSize: 100, showSizeChanger: true, pageSizeOptions: ['100', '200', '300'] }}
							loading={loading} columns={columns} dataSource={eventsData} />
					</Card>

				</MDBCol>
			</MDBRow>
		</div>
	)
}

export default Tasks;
